import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-am",
  "use": "icon-icon-am-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-am\">\n  <path fill=\"#d90012\" d=\"M0 0h512v170.7H0z\" />\n  <path fill=\"#0033a0\" d=\"M0 170.7h512v170.6H0z\" />\n  <path fill=\"#f2a800\" d=\"M0 341.3h512V512H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol